export const LIFE_EVENT_CHANGES_QUERY_KEY = 'life_event_changes';
